import { render, staticRenderFns } from "./subTab1.vue?vue&type=template&id=f6e14a46&scoped=true"
import script from "./subTab1.vue?vue&type=script&lang=js"
export * from "./subTab1.vue?vue&type=script&lang=js"
import style0 from "./subTab1.vue?vue&type=style&index=0&id=f6e14a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e14a46",
  null
  
)

export default component.exports